/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_Files_VInputs */

const en_home_spec_files_v = /** @type {(inputs: Home_Spec_Files_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DWG, DXF, PDF, SVG, PNG`)
};

/**
* | output |
* | --- |
* | "DWG, DXF, PDF, SVG, PNG" |
*
* @param {Home_Spec_Files_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_files_v = /** @type {((inputs?: Home_Spec_Files_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_Files_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_files_v(inputs)
});
export { home_spec_files_v as "home.spec.files_v" }